import styled from 'styled-components'
import { Input } from 'antd'
import { SPACING } from '../../../styles/theme'

export const StyledInput = styled(Input)`
  margin-top: ${SPACING.lg};
`
